module.exports = __webpack_public_path__ + "img/autonomy.29b2da2a.png";